 import {createRouter, createWebHashHistory} from 'vue-router'
 import store from '@/store'
 import { getToken,getExpiredAt,removeToken,removeExpiredAt} from '@/utils/auth'
 import defaultSettings from '@/settings'
 import { login, logout } from '@/utils/is4'
 import {ElMessage} from 'element-plus'
var routes = [
	{
	  path: '/login',
	  // name: 'Login',
		// component: () => import(`@/views/account/login`),
		component: () => import(`@/views/account/login`),
	  hidden: true,
	  meta: {
		title: '登录'
	  }
	},
	{
	  path: '/userBehavior/meditationReport',
	  component: () => import(`@/views/userBehavior/meditationReport`),
	  hidden: true,
	  meta: {
		title: '冥想报告',
		noAuth: true // 标记为不需要权限校验
	  }
	},
	{
	  path: '/userBehavior/medicalSleepReport',
	  component: () => import(`@/views/userBehavior/medicalSleepReport`),
	  hidden: true,
	  meta: {
		title: '医疗睡眠报告',
		noAuth: true // 独立页面，无侧边栏，无需权限
	  }
	},
	{
	  path: '/',
	  // component:(resolve) => require([`@/layout`], resolve),
	  component: () => import(`@/layout`),
	  children: [],
	  name: 'layout',
	  meta: {}
	},
]
const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})
// 生成路由
function generateRoutes(menus = []) {
	const routes = {
	    path: '/',
	    // component:(resolve) => require([`@/layout`], resolve),
	    component: () => import(`@/layout`),
		children: [],
		name: '',
		meta: {}
	}
	if(menus && menus.length > 0){
	  menus.forEach(m => {
		if (m.list && m.list.length > 0) {
		  m.list.forEach(element => {
			  // 排除冥想报告、医疗睡眠报告，已有独立无权限页面
			  if (element.menuPath === 'userBehavior/meditationReport' || element.menuPath === 'userBehavior/medicalSleepReport') {
				return
			  }
			  const route = {
				name: element.menuPath,
				path: '/'+ element.menuPath,
				// closable:true,
				component: () => import(`@/views/${element.menuPath}`),
				meta: {
				  title: element.menuName,
				  icon: element.icon,
				  closable: null,
				  path: '/'+ element.menuPath,
				  closable:true
				}
			  }
			  routes.children.push(route)
		  });
		}
	  })
	}
  
	// 修复无首页时不显示404
	routes.children.push({
	  path: '',
	  hidden: true
	})
  
	routes.children.push({
		path: '/:catchAll(.*)',
		component: () => import(`@/views/error/404.vue`),
		hidden: true
	})
	
	return [routes]
  }

// 添加路由
export function addRoutes(menus = []) {
	// 生成动态路由
	if (menus && menus.length > 0) {
		const dynamicRoutes = generateRoutes(menus)
		for (let x of dynamicRoutes) {//新方式解决警告
			// router.addRoute("index", x);
			router.addRoute(x);
		}
	}
}
addRoutes(store.getters.menus)



function getPageTitle(pageTitle) {
	return pageTitle
  }
// 登出
export function toLogout() {
	store.dispatch('user/logout')
	if (defaultSettings.is4) {
		logout()
	} else {
		router.push('/login')
	}
}
// 登录
function toLogin(to, next) {
	// 自动登录判断
	// next({ path: '/' })
	if (defaultSettings.is4) {
	  if (to.path === '/callback' || to.path === '/refresh') {
		next()
	  } else {
		login()
	  }
	} else {
	  if (to.path === '/login') {
		next()
	  } else {
		next(`/login?redirect=${to.path}`)
	  }
	}
  }

// 设置缓存视图
function setCachedViews() {
	// 获取视图缓存
	let sessionStorageTabs = sessionStorage.getItem('tabs')
	sessionStorageTabs = sessionStorageTabs ? JSON.parse(sessionStorageTabs) : []
	const cachedViews = sessionStorageTabs.map(t => t.name)
	// 设置存储视图缓存名
	store.commit('tabsView/set_cached_view', cachedViews)
  }
  
  let first = true
  // 路由全局前置守卫
  router.beforeEach(async(to, from, next) => {
	// 独立报告页面（无侧边栏、无权限校验）
	if (to.path === '/userBehavior/meditationReport' && to.meta.noAuth) {
	  document.title = getPageTitle(to.meta.title || '冥想报告')
	  next()
	  return
	}
	if (to.path === '/userBehavior/medicalSleepReport' && to.meta.noAuth) {
	  document.title = getPageTitle(to.meta.title || '医疗睡眠报告')
	  next()
	  return
	}
	
	if(to.meta.title === '' || to.meta.title === undefined || to.meta.title === null){
	  document.title = '柔灵后台管理系统'
	}else{
	  document.title = getPageTitle(to.meta.title)
	}
	// 用于判断哪些需要被缓存哪些不需要
	if(to.path === '/userBehavior/monitoringRecords' || to.path === '/userBehavior/meditation' || to.path === '/organization/monitoringRecords' || to.path === '/userBehavior/medicalSideReportRecords'){
	  to.meta.keepAlive = true;
	}else{
	  to.meta.keepAlive = false;
	}
	const token = getToken()
  
	setCachedViews()
  
	if (token) {
		let date = new Date().getTime();
    	let expiredAt = getExpiredAt()
	  if (to.path === '/login') {
		toLogin(to, next)
	  } else {
		const hasPermission = store.getters.menus && store.getters.menus.length > 0
		if (hasPermission) {
		//   next()
			if(getExpiredAt()){
				if (date > expiredAt) {
					removeToken()
					removeExpiredAt()
					next({ path: "/login" });
					ElMessage.error('登录失效，请重新登录！')
				}else{
					next()
				}
			}else{
				next()
			}
		} else {
		  // 仅执行一次
		  if (first) {
			first = false
			const res = await store.dispatch('user/getLoginInfo')
			if (res && res.success) {
			  if (!(res.data?.menuList?.length > 0)) {
				// this.$confirm('无权限，请重新登录！', '提示').then(() => {
				//   toLogin(to, next)
				// }).catch(() => {})
				toLogin(to, next)
				return
			  }
			  next({ ...to, replace: true })
			} else {
			  toLogin(to, next)
			}
		  }
		}
	  }
	} else {
	  toLogin(to, next)
	}
  })
export default router
